/**
 *
 * @param {IterableElementsProps | undefined} elements
 * @returns {Array<TorusElement> | null}
 */
const getIterableElements = (elements) => {
  if (!elements) {
    return null;
  }

  if (typeof elements === "string") {
    return /** @type {Array<TorusElement>} */ ([
      ...document.querySelectorAll(elements),
    ]);
  }

  if (elements instanceof Array && elements.length) {
    return elements;
  }

  if (elements instanceof Node) {
    return [/** @type {TorusElement} */ (elements)];
  }

  if (elements instanceof NodeList) {
    return Array.from(elements, (el) => /** @type {TorusElement} */ (el));
  }

  if (elements instanceof Set && elements.size) {
    return Array.from(elements);
  }

  return [...elements];
};

export default getIterableElements;
